export default {
  namespaced: true,
  state:{
    status: false,
    successSnackbarContents: null,
    errorSnackbarContents: null
  },
  mutations: {
    /**
       * @desc to toggle snackbar status
       * @param state
       * @param payload
       */
    activateSnackbar(state, payload) {
      state.status = payload
    },
    /**
       * @desc to update snackbar success content
       * @param state
       * @param payload
       */
    successSnackbar(state, payload) {
      state.successSnackbarContents = payload
    },
    /**
       * @desc to update snackbar error content
       * @param state
       * @param payload
       */
    errorSnackbar(state, payload) {
      state.errorSnackbarContents = payload
    },
  },
  getters: {
  }
}
